import fetchRequest from "./index";
import { GET_SELECTED_MEETING_RACES_INFO, GET_MEETING_BROADCAST, 
  GET_RACE_PASTWINNERS, GET_FIXTURELIST_SUMMARY, GET_FIXTURELIST, GET_REFERENCEODDS_INFO, 
  GET_SIMPLIFIED_MEETING_RACES_INFO, GET_TRACK_ANALYSIS, GET_TRACK_ANALYSIS_EXPERTS, GET_BANNERS, GET_TIMEOFFSET,
  GET_MEETING_SUMMARY_MENU_TYPE, GET_SEASON_BY_DATE, GET_JOCKEYSTRAINERSRANKING, GET_MEETINGRACE_NEWS, GET_GEARINFO, 
  SEARCH_MEETINGS_BY_DATE, GET_HOME_BASIC_INFO, SEARCH_MEETINGS_IN_DATE_RANGE, GET_EXPERTCOLUMN, GET_HORSE_MEETINGRACE,
  GET_RACE_CARD_COLUMNS, GET_TIPSTERS_SELECTION, GET_MEETING_PM_POOL_STATUS, GET_FORMCOMMENTS,GET_INPAGEDISPLAYBUTTONS, 
  GET_ARTICLE, GET_MEETING_STATUS, SEARCH_CARNIVAL_BY_NAME, GET_RACINGSTATISTICS, GET_CARNIVAL_NAMES, 
  GET_HORSE_PERFORMANCE,GET_CARNIVALSection, GET_MEETINGCOUNTRY_HORSESTATUS_GIDS, GET_MEETING_BROADCASTCONFIG,
  GET_RACE_RESULTS_LIST, GET_RACE_REPLAY,
  GET_OVERRIDE_REDIRECTION_CONFIG,
  GET_UPCOMINGRACE_CMS, GET_UPCOMINGRACE_QIDS,
  GET_UPCOMING_HVST_Mt,
  RACE_REPLAY_VIDEOS
} from "./query";
import { formattedDate, toDayJS, toDate, dateFormat } from "../DayJS";
import { carnivalTemplate, meetingTemplate, racesTemplate } from "@/app/utils/constant/template";
import { oddType } from "@/app/utils/constant/odd";
import { LangCode } from "@/app/utils/LanguageContext";
import {formatDuration} from "@/app/utils/Common";
import { orderBy } from "lodash";
import { pmPoolStatus, meetingStatus } from "../constant/statusSet";
const HK_TIME_OFFSET = -480;
export const getRaceCardList = async (
  variables: any,
  query: any,
  callName: any
) => {
  return await fetchRequest(variables, query, callName);
};
export const getFormTitle = async (
  variables: any,
  query: any,
  callName: any
) => {
  return await fetchRequest(variables, query, callName);
};
export const getRaceInfoList = async (
  variables: any,
  query: any,
  callName: any
) => {
  return await fetchRequest(variables, query, callName);
};

export const getHeader = async (
  variables: any,
  query: any,
  callName: any
) => {
  return await fetchRequest(variables, query, callName);
};

export const getHeaderNavMain = async (
  variables: any,
  query: any,
  callName: any
) => {
  return await fetchRequest(variables, query, callName);
};

export const getRaceSiteMenu = async (
  variables: any,
  query: any,
  callName: any
) => {
  return await fetchRequest(variables, query, callName);
};

export const getRaceMeeting = async (
  variables: any,
  query: any,
  callName: any
) => {
  return await fetchRequest(variables, query, callName);
};

export const getMeetingStatus = async (
  meetingDate: Date,
  venueCode?: string,
  signal?: AbortSignal,
  timeout?: number,
) => {
  const variables = {
    date: formattedDate(meetingDate, "YYYY-MM-DD"), 
    venueCode: venueCode,
    oddsTypes: [oddType.WIN],
  }
  return await fetchRequest(variables, GET_MEETING_STATUS, "qids", undefined, signal, timeout);
};

export const getRacingChanges = async (
  variables: any,
  query: any,
  callName: any
) => {
  return await fetchRequest(variables, query, callName);
};

export const getMeetingGeneralInformation = async (
  variables: any,
  query: any,
  callName: any
) => {
  return await fetchRequest(variables, query, callName);
};

export const getHorseProfile = async (
  variables: any,
  query: any,
  callName: any
) => {
  return await fetchRequest(variables, query, callName);
};

export const getHorsePerformance = async (
  variables: any,
) => {
  return await fetchRequest(variables, GET_HORSE_PERFORMANCE, "qids");
};

export const getWinOddsInfo = async (
  variables: any,
  query: any,
  callName: any
) => {
  return await fetchRequest(variables, query, callName);
};

export const getFooterMenu = async (
  options: any,
  query: any,
  callName: any
) => {
  const variables = { path: "/sitecore/content/Sites/JCRW/SiteConfiguration/Footer", ...options };
  return await fetchRequest(variables, query, callName);
};

export const getRGPBanner = async (
  options: any,
  query: any,
  callName: any
) => {
  const variables = { path: "/sitecore/content/Sites/CorpWebCommon/RGP/02-Racing", ...options };
  return await fetchRequest(variables, query, callName);
};

export const getSelectedMeetingInfo = async (
  langCode: string,
  season: string,
  meetingId: string,
  signal?: AbortSignal,
) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}/Races`,
    language: langCode,
    entriesFolderTemplateIDs: [racesTemplate.RACE.ENTRIES.ID],
  };
  return await fetchRequest(variables, GET_SELECTED_MEETING_RACES_INFO, "cms", undefined, signal);
};

export const getSimplifiedMeetingInfo = async (
  langCode: string,
  season: string,
  meetingId: string,
) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}/Races`,
    language: langCode,
  };
  return await fetchRequest(variables, GET_SIMPLIFIED_MEETING_RACES_INFO, "cms");
};

export const searchMeetingsByDate = async (
  lang: LangCode,
  meetingDate?: Date,
  signal?: AbortSignal,
) => {
  const rootPath = `/sitecore/content/Sites/JCRW/Meetings/Simulcast/`;
  const variables = {
    path: rootPath,
    language: lang,
    meetingDate: formattedDate(meetingDate, "YYYY-MM-DDTHH:mm:ss[Z]", true),
    dateFormat: "d/M/yyyy, hh:mmtt",
    offset: HK_TIME_OFFSET,
  };
    return await fetchRequest(variables, SEARCH_MEETINGS_BY_DATE, "cms", undefined, signal);
};

export const getSelectedMeetingBroadcast = async (
  lang: LangCode,
  season: string,
  meetingDate: Date,
) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Broadcasts/Simulcast/${season}/${formattedDate(meetingDate, "YYYYMMDD")}`,
    language: lang
  };
    return await fetchRequest(variables, GET_MEETING_BROADCAST, "cms");
};

export const getBroadcastConfig = async (
  lang: LangCode,
) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Simulcast/BroadcastConfig`,
    language: lang
  };
    return await fetchRequest(variables, GET_MEETING_BROADCASTCONFIG, "cms");
};

export const getReferenceInfo = async (
  lang: LangCode,
  season: any,
  meetingId: any,
  raceNo:any
) => {
  
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}/Races/${raceNo}/ReferenceOdds`,
    language: lang
  };
    return await fetchRequest(variables, GET_REFERENCEODDS_INFO, "cms");
};

export const getFormComments = async (
  lang: LangCode,
  season: any,
  meetingId: any,
  raceNo:any
) => {
  
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}/Races/${raceNo}`,
    language: lang
  };
    return await fetchRequest(variables, GET_FORMCOMMENTS, "cms");
};

export const getPastWinners = async (
  lang: LangCode,
  season: string,
  meetingId: string,
  raceId: string
) => {
  
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}/Races/${raceId}/PastWinners`,
    language: lang
  };
    return await fetchRequest(variables, GET_RACE_PASTWINNERS, "cms");
};

export const getRaceResultsList = async (
  meetingDate: Date,
  venueCode: string,
  signal?: AbortSignal,
  timeout?: number,
) => {
  const variables = {
      date: formattedDate(meetingDate, "YYYY-MM-DD"),
      venueCode: venueCode
  };
  return await fetchRequest(variables, GET_RACE_RESULTS_LIST, "qids", undefined, signal, timeout);
};

export const getFixtureList = async (
  lang: string,
  isSummary?: boolean, // true, will get config for calendar column; false: fixture list column
  season?: string // "22_23", default retrieve latest season 
) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Simulcast/FixtureList`,
    language: lang,
    racesFolderTemplateIDs: [meetingTemplate.RACES.ID]
  };

  var calendarFixtureList: IFixture[] = [];
  var seasonList: string[] = [];
  var res = await fetchRequest(variables, isSummary ? GET_FIXTURELIST_SUMMARY : GET_FIXTURELIST, "cms");
  res?.data?.season?.reduce((prev: any, current: any) => {
    if (current?.currentSeason?.boolValue) {
      seasonList = [prev?.displayName, current?.displayName];
      if (isSummary) {
        calendarFixtureList = current?.fixtureSorting?.targetItems?.concat(prev?.fixtureSorting?.targetItems || []) || [];
      }
      return current
    }
    return current
  }, "")

  res = {
    ...res,
    data: {
      fixtureList: isSummary ? calendarFixtureList : // all season for calendar view
        res?.data?.season?.find((s: { currentSeason: { boolValue: boolean }; displayName: string; }) => !season && s?.currentSeason?.boolValue || (season && s?.displayName == season))?.fixtureSorting?.targetItems || [], // latest season on fixture list
      seasonList
    }
  }

  return res;
};

export const getDisclaimer = async (
  options: any,
  query: any,
  callName: any,
  isCarnival?: boolean
) => {
  const variables = { path: `/sitecore/content/Sites/JCRW/Simulcast/${isCarnival ? "Carnival_" : ""}Disclaimer`, ...options };
  return await fetchRequest(variables, query, callName);
};

export const getTrackAnalysis = async (
  lang: LangCode,
  season: string,
  meetingId: string
) => {
  
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}/TrackAnalysis`,
    language: lang
  };
    return await fetchRequest(variables, GET_TRACK_ANALYSIS, "cms", undefined);
};

export const getTrackAnalysisExperts = async (
  lang: LangCode,
  expertsName: string
) => {
  
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Simulcast/Experts//${expertsName}`,
    language: lang
  };
    return await fetchRequest(variables, GET_TRACK_ANALYSIS_EXPERTS, "cms");
};

export const getBanners = async (
  lang: LangCode,
  bannerType: "Top" | "Bottom" | "Middle"
) => {
  let bannerPath = "";
  switch (bannerType) {
    case "Top":
      bannerPath = "TopBanners";
      break;
    case "Middle":
      bannerPath = "BannerWithText";
      break;
    case "Bottom":
      bannerPath = "BottomCarnivalBanners";
      break;
    default:
      break;
  }

  const variables = {
    path: `/sitecore/content/Sites/JCRW/Banners/Simulcast/${bannerPath}`,
    language: lang
  };
  return await fetchRequest(variables, GET_BANNERS, "cms");
};

export const getBusinessDate = async (signal?: AbortSignal) => {
  return await fetchRequest(null, GET_TIMEOFFSET, 'qids', undefined, signal);
};

export const getMeetingSummaryMenuType = async () => {  
  const variables = {
    path: "/sitecore/content/Sites/JCRW/Simulcast/MeetingSummaryMenu",
    language: "en-us",
  };
  return await fetchRequest(variables, GET_MEETING_SUMMARY_MENU_TYPE, 'cms', undefined);
};

export const searchSeasonByDate = async (dateStr: string, lang: LangCode, signal?: AbortSignal) => {
  const rootPath = "/sitecore/content/Sites/JCRW/Meetings/Simulcast/"
  const variables = {
    path: rootPath,
    dateStr: dateStr,
    limit: 1, // return first result if more than one
    language: lang,
  };
  return fetchRequest(variables, GET_SEASON_BY_DATE, 'cms', undefined, signal).then((res)=> res?.search?.results?.items[0]?.path.toLowerCase().replace(rootPath.toLowerCase(), '').split("/")[0] || '');
};

export const getJockeysTrainersRanking = async (
  lang: LangCode,
  season: string,
  meetingId: string
) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}/JockeysTrainersRankings`,
    language: lang
  };
  var res = await fetchRequest(variables, GET_JOCKEYSTRAINERSRANKING, "cms");
  return res
}

export const getMeetingRaceNews = async (
  lang: LangCode,
  meetingraceid: string
) => {
  
  const variables = {
    path: `/sitecore/content/Sites/JCRW/News/`,
    language: lang,
    fieldid: meetingraceid,
    offset: HK_TIME_OFFSET,
  };
    return await fetchRequest(variables, GET_MEETINGRACE_NEWS, "cms");
};

export const getGearInfo = async (
  lang: LangCode, 
) => {
  
  const variables = {
    path: `/sitecore/content/Sites/JCRW/SiteConfiguration/GearInfo`,
    language: lang
  };
    return await fetchRequest(variables, GET_GEARINFO, "cms");
};

export const getHomeBasicInfo = async (meetingsOnly?:boolean, signal?: AbortSignal) => {  
  const variables = {
    localSim: "SIM",
    meetingsOnly: meetingsOnly,
    oddsTypes: [oddType.WIN],
  };
  return await fetchRequest(variables, GET_HOME_BASIC_INFO, "qids", undefined, signal);
};

export const searchMeetingsInDateRange = async (lang: LangCode, from?: Date, to?: Date, signal?: AbortSignal) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast`,
    language: lang,
    fieldsEqual: [{name: "_templateName", value: meetingTemplate.NAME}],
    from: formattedDate(from, "YYYY-MM-DDTHH:mm:ss[Z]", true),
    to: formattedDate(to, "YYYY-MM-DDTHH:mm:ss[Z]", true),
    racesFolderTemplateIDs: [meetingTemplate.RACES.ID],
  };
  return await fetchRequest(variables, SEARCH_MEETINGS_IN_DATE_RANGE, "cms", undefined, signal);
};

export const getOverrideRedirectionConfig = async (lang: LangCode, signal?: AbortSignal) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Simulcast/OverrideRedirectionConfig`,
    language: lang,
    racesFolderTemplateIDs: [meetingTemplate.RACES.ID],
  };
  return await fetchRequest(variables, GET_OVERRIDE_REDIRECTION_CONFIG, "cms", undefined, signal);
};

export const getRaceCardColumns = async (
  lang: LangCode,
) => {
  const variables = {
    path: "/sitecore/content/Sites/JCRW/SiteConfiguration/RaceCard_Columns",
    language: lang
  };
  return await fetchRequest(variables, GET_RACE_CARD_COLUMNS, "cms");
}

export const getExpertColumn = async (
  lang: LangCode, 
  season: any,
  meetingId: any,
  raceNo:any
) => {
  
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}/Races/${raceNo}/ExpertColumn`,
    language: lang
  };
    return await fetchRequest(variables, GET_EXPERTCOLUMN, "cms");
};

export const getHorseByMeetingRace = async (
  meetingDate: string,
  venCode: string,
  raceNumber: string, 
  ids: any
  ) => {  
  const variables = {
    meetingDate: meetingDate, 
    venCode: venCode,
    raceNumber: raceNumber,
    ids: ids ?? []
  };
  return await fetchRequest(variables, GET_HORSE_MEETINGRACE, "qids");
};

export const getTipstersSelection = async (
  lang: LangCode,
  season: string,
  meetingId: string
) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}/TipstersSelections`,
    language: lang
  };
  var res = await fetchRequest(variables, GET_TIPSTERS_SELECTION, "cms");
  return res
};

export const getMeetingPmPoolStatus = async (
  meetingDate: string,
  venCode: string,
  oddsTypes?: any
) => {
  const variables = {
    date: meetingDate, 
    venueCode: venCode,
    oddsTypes: oddsTypes ?? ["WIN"]
  };
  var res = await fetchRequest(variables, GET_MEETING_PM_POOL_STATUS, "qids");
  return res
};

export const getInPageDisplayButtons = async (  
  lang: LangCode, 
  season: any,
  meetingId: any,
  speedMapPath: string
) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}`,
    path_SpeedMap: `/sitecore/media library/Sites/JCRW/Speedmap/Simulcast/${speedMapPath}`,
    path_DefaultButtonsMap: `/sitecore/content/Sites/JCRW/Simulcast/InPageDisplayDefaultButtons`,    
    language: lang
  };
  var res = await fetchRequest(variables, GET_INPAGEDISPLAYBUTTONS, "cms", undefined);
  return res
};

export const getArticle = async (
  lang: LangCode,
  season: any,
  meetingId: any,
  name: string
) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}/InPageDisplayButtons/${name}`,
    language: lang
  };
  var res = await fetchRequest(variables, GET_ARTICLE, "cms");
  return res
};

export const getCarnivalSection = async (
  lang: string,
  carnival: string,
  raceday: string,
) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Simulcast/Carnivals/${carnival}/${raceday}`,
    language: lang
  };

  var res = await fetchRequest(variables, GET_CARNIVALSection, "cms");
  return res
};

export const searchCarnivalByName = async (
  langCode: LangCode,
  pageName: string,
) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Simulcast/Carnivals`,
    language: langCode,
    fieldsEqual: [
      {name: "_templateName", value: carnivalTemplate.NAME},
      {name: "_name", value: pageName}
    ],
    limit: 1, // return first result if more than one
  };
  return await fetchRequest(variables, SEARCH_CARNIVAL_BY_NAME, "cms");
};

export const getRacingStatistics = async (
  lang: LangCode,
  season: string,
  meetingId: string
) => {
  
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast/${season}/${meetingId}/RacingStatistics`,
    language: lang
  };
    return await fetchRequest(variables, GET_RACINGSTATISTICS, "cms", undefined);
};

export const getCarnivalNameList = async (lang: LangCode) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Simulcast/CarnivalNames`,
    language: lang
  };
  return await fetchRequest(variables, GET_CARNIVAL_NAMES, "cms");
}

export const getMeetingCountryAndHorseStatus = async (
  meetingDate: string,
  venCode: string
) => {
  const variables = {
    date: meetingDate, 
    venueCode: venCode
  };
  return await fetchRequest(variables, GET_MEETINGCOUNTRY_HORSESTATUS_GIDS, "qids");
}

export const getRaceRepaly = async (lang: LangCode, season: string, meetingDate: string, signal?: AbortSignal, timeout?: number) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Local/TV_Programme/Race_Replay/${season}/${meetingDate}`,
    language: lang
  };
  return await fetchRequest(variables, GET_RACE_REPLAY, "cms", undefined, signal, timeout);
}


export const getUpcomingRaceCMS = async (lang: LangCode, from?: Date, to?: Date, signal?: AbortSignal) => {
  const variables = {
    path: `/sitecore/content/Sites/JCRW/Meetings/Simulcast`,
    language: lang,
    fieldsEqual: [{name: "_templateName", value: meetingTemplate.NAME}],
    from: formattedDate(from, "YYYY-MM-DDTHH:mm:ss[Z]", true),
    to: formattedDate(to, "YYYY-MM-DDTHH:mm:ss[Z]", true),
    racesFolderTemplateIDs: [meetingTemplate.RACES.ID],
    entriesFolderTemplateIDs: [racesTemplate.RACE.ENTRIES.ID],
  };
  return await fetchRequest(variables, GET_UPCOMINGRACE_CMS, "cms", undefined, signal);
};

export const getUpcomingRaceQIDS = async (meetingsOnly?:boolean, signal?: AbortSignal) => {  
  const variables = {
    localSim: "SIM",
    meetingsOnly: meetingsOnly,
    oddsTypes: [oddType.WIN],
  };
  return await fetchRequest(variables, GET_UPCOMINGRACE_QIDS, "qids", undefined, signal);
};

export const getupcomingRacecard = async (langCode:any, resBizdate:any, t: any, signal:any) => {
  const bizDate = toDate(resBizdate?.timeOffset?.ts, dateFormat.qids.date);
  const _cmsPromise = new Promise((resolve, reject) => {
        getUpcomingRaceCMS(langCode, toDayJS(bizDate)?.toDate(), toDayJS(bizDate)?.add(3, 'month')?.toDate(), signal)
        .then((res:any) => {
             resolve(res)
        }).catch((e: any) => {
            console.log('getUpcomingRaceCMS err:', e);
            resolve(undefined);
        });
    }) 
    const _qidsPromise = new Promise((resolve, reject) => {
        getUpcomingRaceQIDS(false, signal)
        .then((res:any) => {
            resolve(res?.commonMeetings)
        }).catch((e: any) => {
            console.log('getUpcomingRaceCMS err:', e);
            resolve(undefined);
        });
    }) 

    const [_cmsRes, _qidsRes] = await Promise.allSettled([
      _cmsPromise,
      _qidsPromise,
    ]) as any;
    const _cmsSearchItem = _cmsRes?.value?.extendedSearch?.results?.items;
    const _validqids_results = _qidsRes?.value?.filter((mt:any) => ![meetingStatus.DRAFT].includes(mt?.status)) // remove DRAFT meeting
    const _meetingFilter = [] as any;
    const _upComingList = [] as any;
    const isEn = langCode == "en-us";
    const curDateOffsetTime = new Date((new Date().getTime()) + (resBizdate?.timeOffset?.rc*1000));

    const getCMSupComingRes = (result:any) => {
      const engLabelItem = _cmsRes?.value?.engLabelSearch?.results?.items;
      const temp_cmsRes = result;

      temp_cmsRes?.forEach((item:any, index:any) => {
        // presite uncheck
        if (!item?.meeting?.presite?.boolValue && item?.meeting?.races?.[0]?.raceInfo?.length) {
          const enCountryName = engLabelItem?.find((x:any)=>x?.meeting?.id === item?.meeting?.id)?.meeting?.countryName?.value;
          const firstRaceDate = toDate(item?.meeting?.races?.[0]?.raceInfo?.[0]?.raceDatetime?.value || '', dateFormat.cms.datetime);
            const _mainRace = item?.meeting?.mainRace?.targetItem?.displayName || "";
            const mainRace = _mainRace.split('_')[_mainRace.split('_').length-1]?.replace(/[^0-9]/g, '') || 1;
            _meetingFilter?.push(
                {
                    meetingDate: item?.meeting?.meetingDate?.date,
                    venueCode: item?.meeting?.meetingVenueCode?.value,
                    lable: item?.meeting?.meetingVenueCode?.value + " - " + item?.meeting?.countryName?.value,
                    id: item?.meeting?.id,
                    enLabel: item?.meeting?.meetingVenueCode?.value + " - " + enCountryName,
                    postTimeOrder: firstRaceDate?.getTime(),
                    currentNumberOfRace: mainRace,
                    dataSourse: "cms",
                }
            )

            const worldPoolSrc = item?.meeting?.RaceImages?.targetItems?.[0]?.RaceimageURL?.src || ""
            item?.meeting?.races?.[0]?.raceInfo?.forEach((race: any) => {
                const raceDate = toDate(race?.raceDatetime?.value || '', dateFormat.cms.datetime);
                const raceDateStr = formattedDate(raceDate, "DD/MM");
                const da = toDayJS(curDateOffsetTime);
                const db = toDayJS(race?.raceDatetime?.value);
                const seconds = db?.diff(da, 'second') || 99999; 

                const _countryNm = item?.meeting?.countryName?.value?.replaceAll(" ", "")?.toUpperCase();
                const isEntriesReady = race?.entries?.length > 0;
                const cmsMtId = item?.meeting?.id;
                const cmsMtDate = item?.meeting?.meetingDate?.date?.replaceAll("-","");
                const countryNm = (_countryNm && t(`ContryCode_${_countryNm}`).indexOf("ContryCode_") == -1 && t(`ContryCode_${_countryNm}`) ) || ""
                const _cms_card = {
                    postdate : raceDateStr,
                    timeLeft : formatDuration(seconds, langCode, t, "", false),
                    less9min: seconds < (window?.globalConfig?.UPCOMINGCONFIG?.RED_COUNTDOWN || 60*9),
                    venueCodeRaceNo: race?.venueCode?.value,
                    country: countryNm,
                    raceName: race?.raceName?.value,
                    isTurf: /(草地|Turf)$/.test(race?.raceDistance?.value),
                    
                    isWorldPool: worldPoolSrc,
                    id: item?.meeting?.id,
                    raceId: cmsMtId + race?.venueCode?.value,
                    raceDate: cmsMtDate,
                    raceCourse: race?.venueCode?.value?.split?.("-")?.[0],
                    raceNo: race?.venueCode?.value?.split?.("-")?.[1],
                    status: "",
                    statusOrder: 2,
                    isEntriesReady,
                    dataSourse: "cms",
                    postTime: raceDate,
                    postTimeOrder: raceDate?.getTime(),
                }
                _upComingList.push(_cms_card);
            })
        }
      })
    }
    if (_validqids_results?.length) {
        _validqids_results?.forEach((mt:any) => {   
            // CMS is presite check
            const ispresiteUncheck_mt = _cmsSearchItem?.find((item:any) => 
            // item?.meeting?.season?.name == mt?.season?.replace("/", "_") &&  
            item?.meeting?.meetingVenueCode?.value== mt?.venueCode
            && item?.meeting?.meetingDate?.date == mt?.date   
            && !item?.meeting?.presite?.boolValue); 
            console.log('ispresiteUncheck_mt----', ispresiteUncheck_mt)
            if (ispresiteUncheck_mt && mt?.races?.length) {
                const _country = mt?.country?.map((i:any) => langCode == "en-us" ? i?.nameen : i?.namech)?.join("/");
                const _country_en = mt?.country?.map((i:any) => i?.nameen)?.join("/");
                const firstRaceDate = toDate(mt?.races?.[0]?.postTime || '', dateFormat.cms.datetime);
                const _mainRace = ispresiteUncheck_mt?.meeting?.mainRace?.targetItem?.displayName || "";
                const mainRace = _mainRace.split('_')[_mainRace.split('_').length-1]?.replace(/[^0-9]/g, '') || 1;
                _meetingFilter?.push(
                    {
                        meetingDate: mt?.date, 
                        venueCode:  mt?.venueCode,
                        lable: `${mt?.venueCode} - ${_country}`,
                        id: mt?.id,
                        enLabel: `${mt?.venueCode} - ${_country_en}`,
                        postTimeOrder: firstRaceDate?.getTime(),
                        currentNumberOfRace: mt?.currentNumberOfRace || mainRace,
                        dataSourse: "qids",
                    }
                )
                const cmsMtId = ispresiteUncheck_mt?.meeting?.id;
                const cmsMtDate = ispresiteUncheck_mt?.meeting?.meetingDate?.date?.replaceAll("-","");
                mt?.races?.forEach((race :any, index: any) => {
                    const raceDate = toDate(race?.postTime || '', dateFormat.cms.datetime);
                    const raceDateStr = formattedDate(raceDate, "DD/MM");

                    const da = toDayJS(curDateOffsetTime);
                    const db = toDayJS(race?.postTime);
                    const seconds = db?.diff(da, 'second') || 99999; 
                    
                    const _status =  race?.status;
                    const _pmpoolStatus = mt?.pmPools?.find((p:any) => p?.leg?.races?.[0] == race?.no)?.status;
                    

                    const JumpedPmPoolStatus = [
                      pmPoolStatus.STOP_SELL,
                      pmPoolStatus.CLOSED,
                      pmPoolStatus.CLOSED_AFTER_REFUND,
                      pmPoolStatus.PAYOUT,
                      pmPoolStatus.REFUND_BEFORE_CLOSE,
                      pmPoolStatus.REFUND_AFTER_CLOSE];
                    const isJumped = JumpedPmPoolStatus.includes(_pmpoolStatus) || ["RESULT", "CLOSED"].includes(_status);
                    const isEntriesReady = ispresiteUncheck_mt?.meeting?.races?.[0]?.raceInfo?.find((r:any) => r?.venueCode == `${mt?.venueCode}-${race?.no}`)?.entries?.length > 0;
                    const _card = {
                        postdate : raceDateStr,
                        timeLeft : formatDuration(seconds, langCode, t, _status, isJumped),
                        less9min: seconds < (window?.globalConfig?.UPCOMINGCONFIG?.RED_COUNTDOWN || 60*9),
                        venueCodeRaceNo: mt?.venueCode+"-"+race.no,
                        country: race?.countryCodeNm?.english,
                        raceName: isEn ? race?.raceName_en: race?.raceName_ch,
                        isTurf: race?.raceTrack?.description_en == "Turf",
                        
                        isWorldPool: ispresiteUncheck_mt?.meeting?.RaceImages?.targetItems?.[0]?.RaceimageURL?.src || "",
                        id: mt?.id,
                        raceId: cmsMtId + mt?.venueCode+"-"+race.no,
                        raceDate: cmsMtDate,
                        raceCourse: mt?.venueCode,
                        raceNo: race?.no,
                        status: _status,
                        statusOrder: isJumped ? 1 : 2,
                        postTimeOrder: raceDate?.getTime(),
                        isEntriesReady,
                        dataSourse: "qids",
                        postTime: raceDate,
                    }
                    _upComingList.push(_card)
                  })
            }
        });

        // if has futrue meeting on cms 
        if(_cmsSearchItem?.length) {
          const _temp = _cmsSearchItem?.filter((c:any) => !(_upComingList.find((u:any) =>
              c?.meeting?.meetingVenueCode?.value == u?.raceCourse &&
              c?.meeting?.meetingDate?.date?.replaceAll("-", "") == u?.raceDate)));
          if (_temp?.length) {
              getCMSupComingRes(_temp)
          }
        }
    } else if (_cmsSearchItem?.length){
      getCMSupComingRes(_cmsSearchItem)
    }

    const _upComingList_order = orderBy(_upComingList, ["postTimeOrder",], ["asc"]);
    const _meetingFilter_order = orderBy(_meetingFilter, ["postTimeOrder"], ["asc"]);
    const result = {
        _None: !_upComingList.length,
        _upComingList: _upComingList_order,
        _meetingFilter: _meetingFilter_order,

    }
    console.log("upComing---", result, _cmsRes.value, _validqids_results)
    return result
}

export const getUpcomingHVSTMt = async (
  meetingDate: string,
  signal?: AbortSignal
) => {
   const variables = {
    dates: !meetingDate ? null : [meetingDate?.replaceAll?.("/", "-")],
    venueCodes: ["ST","HV"]
  };
  return await fetchRequest(variables, GET_UPCOMING_HVST_Mt, "qids", undefined, signal);
};

export const getRaceReplayVideos = async (
  meetingDate: string, // in "DD/MM/YYYY"
  venueCode: string,
  raceNo: string,
) => {
  const variables = {meetingDate, venueCode, raceNo};
  return await fetchRequest(variables, RACE_REPLAY_VIDEOS, "qids");
};